<!--注册账号-->
<template>
  <div class="register-container" v-loading="loading" :element-loading-text="loadingText"
       element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.7)">
    <headerIndex/>
    <div class="register-content">
      <p class="span-default">注册账号</p>
      <p class="smaller-span">已有账号？
        <el-link type="primary" :underline="false" @click="loginOut" class="el-active">立即登录</el-link>
      </p>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item prop="account">
          <el-input v-model="ruleForm.account" maxlength="11" placeholder="请输入手机号码" clearable>
            <i slot="prefix" class="iconfont icon-shouji"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input v-model="ruleForm.code" maxlength="6" placeholder="请输入验证码">
            <template slot="prefix">
              <i slot="prefix" class="iconfont icon-anquan"></i>
            </template>
            <template slot="suffix">
              <el-link style="color: #1637FF;font-size: 14px;" class="SourceHanSansCN" @click="getMobileCode" :underline="false"
                       v-if="timer==120">获取验证码
              </el-link>
              <el-link disabled v-else>{{ timer + 's后重试' }}</el-link>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="ruleForm.password" placeholder="请设置登录密码，密码由8-16位数字、字母和下划线等组成" clearable maxlength="16" type="password" autocomplete="new-password">
            <i slot="prefix" class="iconfont icon-lock"></i>
          </el-input>
        </el-form-item>
        <div class="u-flex SourceHanSansCN" style="padding-bottom: 20px;">
          <span style="font-size: 14px;">阅读并接受</span>
          <span><a style="text-decoration:none;color:rgb(22, 55, 255);font-size:14px;" href="http://customerservice.bangqichat.com/index/agreement/article?aWQ9MjE=" target="_bank">《帮企网用户协议》</a></span>
          <span style="font-size: 14px;">和</span>
          <span><a style="text-decoration:none;color:rgb(22, 55, 255);font-size:14px;" href="http://customerservice.bangqichat.com/index/agreement/article?aWQ9MjA=" target="_bank">《隐私政策》</a></span>
        </div>
        <el-form-item>
          <el-button type="primary" @click="registerNow">立即注册</el-button>
        </el-form-item>
      </el-form>
    </div>
    <footerIndex/>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import footerIndex from '@/components/footer/index';
import {isMobile} from "@/common/tools";
import {verifyMoblie,registerSave} from "@/api/loginApi";
import {sendsms, verifySms} from '@/api/currencyApi'
export default {
  name: "register",
  components: {headerIndex, footerIndex},
  data() {
    /*校验手机号*/
    let checkMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号'));
      }
      if (isMobile(value)) {
        callback();
      } else {
        callback(new Error('请输入正确的手机号码'));
      }
    }
    /*校验密码 密码由8-16位数字、字母下划线等组成*/
    let checkPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'));
      }
      let regex = new RegExp('^(?![0-9]+$)(?![a-zA-Z]+$)(?![_/*+~!@#、|":$%^&*(){}_+=;}{,./?]+$)[0-9A-Za-z_/*+~!@#、|":$%^&*(){}_+=;}{,./?]{8,16}$');
      if (regex.test(value)) {
        callback();
      } else {
        callback(new Error('密码由8-16位数字、字母下划线等组成'));
      }
    }
    return {
      ruleForm: {
        account: '',
        code: '',
        password:'',
      },
      /*短信登录校验*/
      rules:{
        account: [
          { validator: checkMobile, trigger: 'blur' }
        ],
        code:[
          {required:true,message:'请输入验证码', trigger: 'blur'}
        ],
        password: [
          {validator: checkPassword, trigger: 'blur'}
        ],
      },
      timer: 120,
      isClickCode: false,
      loadingText: '',
      loading: false,
    }
  },
  methods: {
    /*跳转登录页面*/
    loginOut() {
      this.$router.replace({
        path: '/login'
      })
    },
    /*立即注册*/
    registerNow(){
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.loadingText = '注册中...';
          /* 验证短信接口 */
          verifySms({smscode: this.ruleForm.code, uuid: this.ruleForm.account}).then(res=> {
            if (res.code == 200) {
              /*保存注册信息*/
              registerSave({affirm_pwd: this.ruleForm.password,mobile: this.ruleForm.account,regip: "",setting_pwd: this.ruleForm.password}).then(res=>{
                if (res.code==200){
                  this.loading = false;
                  this.$message.success('注册成功！');
                  this.$router.replace({
                    path: '/login',
                    query:{
                      mobile:res.data.mobile
                    }
                  })
                }
              })
            }
          })
        } else
          return false
      });
    },
    /*获取验证码*/
    getMobileCode(){
      if (this.timer < 120) {
        return
      }
      if (this.isClickCode) {
        return
      }
      /*校验手机号*/
      if (!isMobile(this.ruleForm.account)) {
        this.$message.error('请输入手机号')
        return
      }
      this.isClickCode = true;
      setTimeout(() => {
        this.isClickCode = false;
      }, 1000);
      this.loading = true;
      this.loadingText = '请稍后...';
      /*验证手机号是否已注册*/
      verifyMoblie({moblie: this.ruleForm.account}).then(res => {
        this.loading = false;
        if (res.code == 201) {
          this.$message.success(res.esg);
        }else{
          /*发送短信验证*/
          sendsms({mobile: this.ruleForm.account, uuid: 0, name: "注册帮企网"}).then(res => {
            this.$message.success('验证码已发送!')
            let timer = setInterval(() => {
              if (this.timer <= 0) {
                clearInterval(timer);
                this.timer = 120;
                return
              } else {
                this.timer--
              }
            }, 1000)
          })
        }
      })
    },
  }
}
</script>
<style scoped>
.register-container >>> .el-input__inner {
  border-radius: 4px;
  border: 1px solid #FAFBFF;
  color: #333333;
  font-size: 14px;
  height: 55px;
  line-height: 55px;
  padding: 0 50px;
}
.register-container >>> input::-webkit-input-placeholder {
  color: #999999;
}
.register-container >>> .el-input__suffix {
  display: flex;
  align-items: center;
  right: 20px;
}
.register-container >>> .el-button--primary {
  color: #FFF;
  background-color: #1637FF;
  border-color: #1637FF;
  width: -webkit-fill-available;
  line-height: 25px;
}
.register-container >>> .el-input__prefix {
  left: 20px;
  color: #666666;
  font-size: 35px;
}
.register-container >>> .iconfont {
  font-size: 19px;
}
.register-container >>> .el-form-item__error {
  color: #FE273B;
  font-size: 12px;
  line-height: 1;
}
.register-container >>> .el-form{
  padding-top: 40px;
}
</style>
<style scoped lang="scss">
.register-container {
  background: center;

  .register-content {
    margin: 5% 36%;

    .span-default {
      font-family: 'SourceHanSansCN';
      font-weight: 100;
      font-size: 24px;
      color: #333;
      margin-block-start: 0em;
      margin-block-end: 20px;
    }

    .smaller-span {
      font-size: 14px;
      color: #666666;
      margin-block-start: 0em;
      margin-block-end: 0px;

      .el-active {
        color: #1637ff;
        font-size: 14px;
        vertical-align: baseline;
      }
    }
  }
}
</style>